import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu"
import { CreationForm, CreationFormTemplate } from "../../components/form/CreationForm";
import { ChangePassFormTemplate, MyAccountFormTemplate } from "../../data-parsing/myAccount/FormTemplate";
import { Admin } from "../../data-parsing/admins/Admin";
import { useMyself } from "../../hooks";
import { User } from "../../data-parsing/users/User";
import { ResponseStatus, StatusContextApi } from "../../context/status";
import { useContext, useEffect, useState } from "react";
import { getKeyByValue } from "../../data-parsing/parseUtils";
import { PrimeReactProvider } from "primereact/api";
import { TestUploadImage } from "../_alreylz/DevUtils";
import { useGetMyselfDoctor } from "../myAccount/index"
import { Calendar } from 'primereact/calendar';
import API from "../../api/api";

export function MiCuenta() {

   const { addMessage } = useContext(StatusContextApi);

   const myUser = sessionStorage.getItem("user");

   const isDoctor = sessionStorage.getItem("doctor") === "true" || false;

   //Gets the info of a doctor
   const { doctorInfo, isFetching, gotError, updateDoctorInfo, updatePassword } = useGetMyselfDoctor(sessionStorage.getItem("userid"))



   function validateFields(formData) {
      if (formData.get(getKeyByValue(User, User.password)) !== formData.get(getKeyByValue(User, User.passwordVerification))) {
         addMessage(ResponseStatus.ERROR, 5000, "Los valores de contraseña introducidos no coinciden");
         return false;
      }
      return true;
   }



   return (
      <LeftSideMenu active="nutritionist/miCuenta">


         <div className="container">


            <div id="wrapper">
               <div className="col-xs-12">
                  <div className="card-box card-tabs m-t-20">
                     <div className="row">
                        <h4 className="header-title m-r-10 m-t-0 pull-right">MI CUENTA</h4>
                     </div>
                     <div className="row">


                        <CreationForm createFunction={(data) => updatePassword(
                           { ...doctorInfo, ...data })} v

                           validateForm={validateFields}>

                           <CreationFormTemplate formTemplate={ChangePassFormTemplate} dataTemplate={Admin} />

                           <div className="col-sm-12">
                              <button
                                 className="btn btn-rounded btn-purple m-b-20 ml-10"><i
                                    className="far fa-save"></i> Cambiar
                                 Contraseña
                              </button>

                           </div>
                        </CreationForm>
                     </div>
                  </div>

               </div>
            </div>
         </div>
      </LeftSideMenu>)
}









